<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">

    <thead>
      <tr>
          <th *ngFor="let head of dataTable.headerRow" > <b>{{ head }}</b> </th>
          <th *ngIf="actions" class="disabled-sorting" style="text-align: right;"> <b>Actions</b> </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of dataTable.dataRows">
        <td *ngFor="let value of row">{{value}}</td>
        <td *ngIf="actions" style="text-align: right;">
          <label *ngFor="let boton of buttons">

            <a *ngIf="boton.enabled && boton.type === 'just-icon'"
              class="btn btn-link {{boton.color}} btn-just-icon" 
              (click)="saveEmit(boton.action, row[0], row)">
            <i class="material-icons">{{boton.icon}}</i></a>

            <button *ngIf="boton.enabled && boton.type === 'btn'"
                    class="btn btn-sm btn-{{boton.color}}" (click)="saveEmit(boton.action, row[0], row)">
              <i class="material-icons">{{boton.icon}}</i> &nbsp; {{boton.action}}
            </button>
          </label>
          
        </td>
      </tr>
    </tbody>

  </table>
</div>